import { render } from "./BuyerCreate.vue?vue&type=template&id=41e4c611"
import script from "./BuyerCreate.vue?vue&type=script&lang=js"
export * from "./BuyerCreate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__